const leaveReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default leaveReducer;